export default __webpack_public_path__ + "static/inmovalles_title-ab8f7cbcf063d8f2d69e2c67fdf5c0af.svg";